import React from 'react';
import { Aggregator } from '../../../domain/types';
import { Property, PublishedOn } from '../../../providers/api/dtos';
import ViewPublishedOnPopoverPreview from '../../containers/view-published-on-popover-preview/ViewPublishedOnPopoverPreview';
import PublishedOnStatusIcon from '../published-on-status-icon/PublishedOnStatusIcon';

export interface PublishedOnPreviewProps extends React.AriaAttributes {
  property: Partial<Pick<Property, 'status'>>,
  aggregator: Aggregator,
  publishedOn?: PublishedOn,
  canViewError?: boolean,
  canViewPublishedAt?: boolean,
  canVisit?: boolean,
  canViewPromotion?: boolean,
  canEditPromotion?: boolean,
  onEdit?: (publishedOn: PublishedOn) => void,
  size?: number,
}

const PublishedOnPreview: React.FC<PublishedOnPreviewProps> = ({
  property,
  aggregator,
  publishedOn,
  canViewError = false,
  canViewPublishedAt = false,
  canVisit = false,
  canViewPromotion = false,
  canEditPromotion = false,
  onEdit,
  size,
  ...rest
}) => {
  if (!publishedOn) {
    return (
      <PublishedOnStatusIcon
        aggregator={aggregator}
        size={size}
      />
    );
  }

  return (
    <ViewPublishedOnPopoverPreview
      {...rest}
      property={property}
      publishedOn={publishedOn}
      canViewError={canViewError}
      canViewPublishedAt={canViewPublishedAt}
      canViewPromotion={canViewPromotion}
      canVisit={canVisit}
      canEditPromotion={canEditPromotion}
      onEdit={onEdit}
      trigger={(
        <PublishedOnStatusIcon
          size={size}
          aggregator={aggregator}
          status={publishedOn.aggregatorStatus}
          url={publishedOn.url}
        />
      )}
    />
  );
};

export default PublishedOnPreview;
